import PaymentRequestsBalanceWidget from './index.vue'
export default PaymentRequestsBalanceWidget